import { gql } from "config/graphql";
import { IState } from "config/types";
import { gqlQuery } from "store/apollo";

interface IStatesResponse {
  data: {
    states: IState[];
  };
}

export const statesQuery = (countryId: string): Promise<IStatesResponse> => {
  const query = gql`
    query States($countryId: ID!) {
      states(countryId: $countryId) {
        id
        name
        alpha2
      }
    }
  `;

  return gqlQuery<IStatesResponse["data"]>({ variables: { countryId }, query });
};
